const React = require("react");
const Ripple = require("../../../../../../../dumb/Ripple");

module.exports = ({id, children, active, onClick}) => (
  <Ripple
    className={`
      h56 layoutRow jcC aiC c3E4044 ttU b0 br1 bsrSolid bcrE8E8E8 
      bcrT:last-child rlb9:first-child rrb9:last-child
      bg3E4044.active cF.active bcrE8E8E8.active
      ` + (active ? ' active' : '')
    }
    onClick={() => onClick && onClick(id)}
  >
    {children}
  </Ripple>
)